import CrucibleMetadata from '../../crucibleMetadata';
import extras from './extras.json';
import { ArcaneRings } from './arcaneRings';
import CruciblePiece from '../cruciblePiece';
import CrucibleLoader from '../../crucibleLoader';

export default function getCrucibleExtras(
  metadata: CrucibleMetadata,
  color: THREE.Color,
  loader: CrucibleLoader,
  renderer: THREE.WebGLRenderer
): CruciblePiece[] {
  const crucibleExtras: CruciblePiece[] = [];

  // Arcane rings
  const arcaneRingsBlockLimit = extras.arcaneRings.blockNumberLimit;
  if (metadata.mintBlockNumber <= arcaneRingsBlockLimit) {
    const arcaneRings = new ArcaneRings(color, renderer, loader);
    crucibleExtras.push(arcaneRings);

    loader
      .loadModel(extras.arcaneRings.modelUrl)
      .then((gltf: any) => arcaneRings.setup(gltf));
  }

  return crucibleExtras;
}
